import { render, staticRenderFns } from "./OrderLinkModal.vue?vue&type=template&id=5b347966"
import script from "./OrderLinkModal.vue?vue&type=script&lang=js"
export * from "./OrderLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports